import React, { useRef, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";

export default function SignatureField({ value, onChange, label }) {
  const sigRef = useRef(null);

  useEffect(() => {
    if (sigRef.current && value) {
      // load existing signature if present
      sigRef.current.fromDataURL(value);
    }
  }, [value]);

  const handleEnd = () => {
    if (!sigRef.current) return;
    const dataUrl = sigRef.current.toDataURL("image/png");
    onChange(dataUrl);
  };

  const clear = () => {
    sigRef.current?.clear();
    onChange("");
  };

  return (
    <div style={{ marginTop: 16 }}>
      {label && (
        <div
          style={{
            fontSize: 13,
            color: "#374151",
            marginBottom: 4,
            fontWeight: 500,
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          border: "1px solid #d1d5db",
          borderRadius: 8,
          padding: 4,
          background: "white",
        }}
      >
        <SignatureCanvas
          ref={sigRef}
          canvasProps={{
            width: 500,
            height: 150,
            style: { width: "100%", height: 150, borderRadius: 6 },
          }}
          onEnd={handleEnd}
        />
      </div>
      <button
        type="button"
        onClick={clear}
        style={{
          marginTop: 6,
          fontSize: 12,
          border: "none",
          background: "transparent",
          color: "#2563eb",
          textDecoration: "underline",
          cursor: "pointer",
        }}
      >
        Clear signature
      </button>
    </div>
  );
}
